import { VerifiedIncomeReport } from "types/landlord/reports";
import { Section } from "views/applications-id-report/components/Section";
import { AssetItem } from "views/applications-id-report/components/SmartRender/AssetItem";
import InfoIcon from "shared/icons/status-icons/info-icon.svg?react";
import { formatToCurrency } from "utils/currency";

interface HousingAssistanceProps {
  housing_assistance_program?: VerifiedIncomeReport["housing_assistance_program"];
}

export const HousingAssistance = ({
  housing_assistance_program
}: HousingAssistanceProps) => {
  return (
    <Section sectionTitle="Housing assistance" maxWidth="none">
      <div className="py-4">
        <div className="flex flex-col gap-2">
          <p className="text-content-700 font-medium text-xs">
            Monthly assistance amount
          </p>
          <p className="text-2xl font-bold text-content-1000">
            {housing_assistance_program?.voucher_amount.cents
              ? formatToCurrency(housing_assistance_program.voucher_amount)
              : "--"}
          </p>
        </div>

        <div className="mt-9">
          <p className="pb-2 border-b border-alpha-40">Vouchers</p>

          <div className="mt-4 mb-6">
            <AssetItem
              url={housing_assistance_program?.asset?.url || ""}
              content_type={
                housing_assistance_program?.asset?.content_type || ""
              }
              filename={housing_assistance_program?.asset?.filename || ""}
              assetName={housing_assistance_program?.asset?.filename || ""}
            />
          </div>

          <div className="flex items-center gap-4">
            <InfoIcon className="text-warning-500 h-5" />
            <p className="text-content-400 font-medium">
              Fraud check not available for vouchers. Please manually review the
              documents
            </p>
          </div>
        </div>
      </div>
    </Section>
  );
};
